import { PayloadAction } from "@reduxjs/toolkit";

import {
  createGenericUISlice,
  GenericState,
  UIState,
} from "../../../../store/HOC/genericUI.slice";

import { ComponentId } from "./enums";

export type PerpetratorFormDataInputs = {
  [ComponentId.REGISTRATION_NUMBER]: string;
  [ComponentId.OC_NUMBER]: string;
};

type PerpetratorState = {
  data: PerpetratorFormDataInputs;
  ui: UIState;
};

const initialState: PerpetratorState = {
  data: {
    [ComponentId.REGISTRATION_NUMBER]: "",
    [ComponentId.OC_NUMBER]: "",
  },
  ui: {
    validated: false,
  },
};

const perpetratorSlice = createGenericUISlice({
  name: "@OC/property/perpetrator",
  initialState: initialState as GenericState<PerpetratorFormDataInputs>,
  reducers: {
    setData: (state, action: PayloadAction<PerpetratorFormDataInputs>) => {
      state.data = action.payload;
      state.ui.validated = true;
    },
  },
});

export const { setData: setPerpetratorFormData } = perpetratorSlice.actions;

export const { reducer } = perpetratorSlice;
